<template>
  <div>
    <vs-popup :title="$t('UploadDocuments')" :active.sync="showModal">
      <div class="pb-10 flex flex-col gap-6" v-if="show">
        <div class="flex flex-col gap-1">
          <label class="text-sm">{{ $t("DocumentType") }}</label>
          <v-select
            :options="documents"
            v-model="documentId"
            :reduce="(x) => x.id"
            @option:selected="resetForm"
          ></v-select>
          <div class="h-6">
            <span
              class="text-danger text-sm mr-1"
              v-if="!documentId && showError"
              >لطفا نوع مدرک را انتخاب کنید</span
            >
          </div>
        </div>
        <div class="flex justify-center w-full" @click="validateDocumentId">
          <div
            :class="[
              documentId
                ? ''
                : 'opacity-75 cursor-not-allowed pointer-events-none',
            ]"
          >
            <vue-upload-multiple-image
              :key="documentId + uploaderKey"
              @upload-success="uploadSuccess"
              @before-remove="resetForm"
              :data-images="uploadedImages"
              :maxImage="1"
              :multiple="false"
              :dragText="$t('DragAndDrop')"
              :browseText="$t('UploadFile')"
              :showEdit="false"
              :showDelete="true"
              :showPrimary="false"
            ></vue-upload-multiple-image>
          </div>
        </div>
        <div class="w-full flex justify-end">
          <vs-button
            @click="validateDocumentId"
            :disabled="!payload.fileContent"
            @click.prevent="uploadImage"
            >{{ $t("Upload") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss"></style>

<script>
import { mapActions } from "vuex";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import vSelect from "vue-select";

export default {
  props: {
    show: { default: false },
    documents: {
      default: [],
    },
  },
  data() {
    return {
      uploadedImages: [],
      uploaderKey: 1,
      documentId: null,
      payload: {},
      showError: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      postImage: "agentsDocumentUpload/uploadSupplierDocument",
    }),
    resetForm() {
      this.payload = {};
      this.uploadedImages = [];
      this.uploaderKey++;
    },
    uploadImage() {
      this.postImage(this.payload).then(() => {
        this.$emit("success");
        this.$emit("close");
        this.$swal({
          position: "center-center",
          type: "success",
          text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
          showConfirmButton: false,
          timer: 2000,
        });
        this.documentId = null;
        this.payload = {};
        this.showError = false;
      });
    },
    uploadSuccess(formData, index, fileList) {
      this.payload = {
        supplierId: this.$route.params.id,
        documentSettingId: this.documentId,
        alt: fileList[index].name,
        fileContent: fileList[index].path,
      };
    },
    validateDocumentId() {
      if (!this.documentId) {
        this.showError = true;
      }
    },
  },
  watch: {
    show() {
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
    VueUploadMultipleImage,
  },
};
</script>
